import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import {TrelloCheckItem} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import {User} from 'projects/core/src/lib/login/data/user';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {SelectItem} from 'primeng/api';
import {Observable, forkJoin} from 'rxjs';
import {Any} from 'json2typescript';
import {CheckItemHeadTag} from 'projects/app-misc/src/app/modules/trello-misc/data/checkitem-head-tag';

@Component({
  selector: 'app-edit-task-checkitem',
  templateUrl: './edit-task-checkitem.component.html',
  styleUrls: ['./edit-task-checkitem.component.scss']
})
export class EditTaskCheckitemComponent implements OnInit, AfterViewInit {
  @Input()
  checkItem: TrelloCheckItem;

  @Input()
  projectId: number;

  @Input()
  users: User[];

  @Input()
  tags = [];

  @Input()
  canEditText = true;

  loadingSpinner = false;
  deleteLoadingSpinner = false;

  progressBar: number;

  itemDescription: string;

  @Output() closeAction = new EventEmitter<void>();
  @Output() updateAction = new EventEmitter<TrelloCheckItem>();
  @Output() deleteAction = new EventEmitter<TrelloCheckItem>();

  @ViewChild('punchItemTextArea', {static: true})
  punchItemTextArea: ElementRef;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  constructor(
    protected dialog: MatDialog,
    private snackBar: MatSnackBar,
    protected trelloService: TrelloService
  ) {
  }

  ngOnInit() {
    this.itemDescription = this.checkItem.name;
  }


  ngAfterViewInit() {
    (this.punchItemTextArea.nativeElement as HTMLElement).focus();
  }

  canSave(): boolean {
    if (!this.canEditText) {
      return true;
    }
    return this.itemDescription && this.itemDescription.length >= 3;
  }

  saveItem() {
    this.loadingSpinner = true;

    const cItem = {
      id: this.checkItem.id,
      name: this.itemDescription,
      trelloId: this.checkItem.trelloId,
      tagTypes: this.checkItem.tagTypes
    } as TrelloCheckItem


    const obsArray: Observable<Any>[] = [];
    obsArray.push(this.trelloService.updateCheckItem(cItem))

    if (this.checkItem.tagTypes && this.checkItem.tagTypes.includes('Amount')) {
      const fTag = this.checkItem.tags?.find(tag => tag.type.name === 'Amount')

      if (fTag) {
        fTag.amount = this.checkItem.changeOrderAmount;
        obsArray.push(this.trelloService.toggleTag(fTag))
      } else {
        cItem.amount = this.checkItem.changeOrderAmount
      }
    }

    forkJoin(obsArray).subscribe(item => {
      this.updateAction.emit(item[0] as TrelloCheckItem);

      if (item[1] as CheckItemHeadTag) {
        this.checkItem.changeOrderAmount = (item[1] as CheckItemHeadTag).amount;

        this.checkItem.tags.forEach(tag => {
          if (tag.type.name === 'Amount') {
            tag.amount = (item[1] as CheckItemHeadTag).amount
          }
        });
      }
      this.loadingSpinner = false;
    }, error => {
      this.loadingSpinner = false;
      this.openSnackBar(error.message)
    })
  }


  hideInputItem() {
    this.closeAction.emit();
  }

  uploadFile(files: File[], filesForm?) {

    const fileArray = [];

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i])
    }

    this.trelloService.checkItemLoading$.next(this.checkItem.id);

    this.trelloService.uploadFile(fileArray, this.checkItem.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3


      } else if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.checkItem.files = this.checkItem.files.concat(projectFiles)
        this.trelloService.checkItemLoading$.next(-1)
        this.progressBar = 0
      }

      filesForm?.clear();
    }, error => {
      this.loadingSpinner = false
      this.openSnackBar(error.message)
      this.progressBar = 0;
    })
  }

  deleteItem() {
    this.deleteLoadingSpinner = true;
    this.deleteAction.emit();
  }

  openSnackBar(message: string, duration = 5000) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'overlap-snackbar',
      verticalPosition: 'top',
    });
  }

  tagChanged(tags: SelectItem[]) {
    this.checkItem.tagTypes = tags.map(tag => tag.value.name);
  }

  onMentionSelect(user: User) {
    return '@' + user.username + ' ';
  }

}
